export const normaliseMoney = (value) => {
  if (typeof value === "number") return value;

  return (
    parseFloat(
      String(value || "")
        .replace(/,/g, "")
        .replace(/[^0-9.-]/g, ""),
    ) || 0
  );
};
